import { SPHPhone } from './../model/sph-phone.model';
import { SPHUser } from './../model/sph-user.model';
import { SPHLicense, SPHApplication } from './../model/sph-license.model';
import { SPHLoggedInUser } from './../model/sph-logged-in-user.model';
import { SPHCompany } from './../model/sph-company.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpErrorResponse } from '@angular/common/http/src/response';
import { AlertController } from 'ionic-angular/components/alert/alert-controller';
import { Loading } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LicenseManagerService {
    public static readonly LICENSEMANAGER_SERVER_URL = "https://license-api.web-and-app.de/";


    //public static readonly AVAILABLE_APPLICATIONS [ ];


    public authErrorLogginRequired$: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(private httpClient: HttpClient, private alertController: AlertController, private domSanitizer: DomSanitizer) {
    }

    public login(username: string, password: string): Observable<SPHLoggedInUser> {
        return this.httpClient
            .post(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'login', { username, password }).map((json) => {
                return SPHLoggedInUser.fromJSON(json);
            });
    }

    public getUsers(authToken: string): Observable<SPHUser[]> {
        return this.httpClient
            .get(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/user', { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response: any[]) => response.map(SPHUser.fromJSON));
    }

    public postUser(user: SPHUser, authToken: string): Observable<SPHUser> {
        const input = user.toJSON();
        return this.httpClient
            .post(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/user/', input, { headers: new HttpHeaders().set('Authorization', authToken) })
            .map(SPHUser.fromJSON);
    }

    public patchUser(user: SPHUser, authToken: string): Observable<SPHUser> {
        return this.httpClient
            .patch(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/user/' + user.id, user.toJSON(), { headers: new HttpHeaders().set('Authorization', authToken) })
            .map(SPHUser.fromJSON);
    }

    public deleteUser(user: SPHUser, authToken: string): Observable<void> {
        return this.httpClient
            .delete(
            LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/user/' + user.id,
            { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response) => {
                console.debug('Deleted user response: ', response);
            });
    }

    public getCompany(id: any, authToken: string): Observable<SPHCompany> {
        return this.httpClient
            .get(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/company/' + id, { headers: new HttpHeaders().set('Authorization', authToken) })
            .map(SPHCompany.fromJSON);
    }

    public getCompanies(authToken: string): Observable<SPHCompany[]> {
        return this.httpClient
            .get(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/company', { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response: any[]) => response.map(SPHCompany.fromJSON));
    }

    public patchCompany(company: SPHCompany, authToken: string): Observable<SPHCompany> {
        return this.httpClient
            .patch(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/company/' + company.id, company.toJSON(), { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response) => SPHCompany.fromJSON(response) );
    }

    public postCompany(company: SPHCompany, authToken: string): Observable<SPHCompany> {
        return this.httpClient
            .post(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/company/', company.toJSON(), { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response: any[]) => SPHCompany.fromJSON(response));
    }

    public deleteCompany(id: string, authToken: string): Observable<void> {
        return this.httpClient
            .delete(
            LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/company/' + id,
            { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response) => {
                console.debug('Deleted company response: ', response);
            });
    }

    public getApplications(authToken: string): Observable<SPHApplication[]> {
        return this.httpClient
            .get(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/application', { headers: new HttpHeaders().set('Authorization', authToken) }) as Observable<SPHApplication[]>;
    }

    public qrCode(licenseID: any, authToken: string): Observable<any> {
        return this.httpClient
            .get(
                LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/license/' + licenseID + '/qrcode',
                { headers: new HttpHeaders().set('Authorization', authToken).set('Accept', 'image/svg+xml'), responseType: 'blob' })
            .map((e) => this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(e)));
    }

    public getLicenses(companyID: any, authToken: string): Observable<SPHLicense[]> {
        return this.httpClient
            .get(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/company/' + companyID + '/licenses', { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response: any[]) => response.map(SPHLicense.fromJSON));
    }

    public postLicense(license: SPHLicense, authToken: string): Observable<SPHLicense> {
        return this.httpClient
            .post(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/license/', license.toJSON(), { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response: any[]) => SPHLicense.fromJSON(response));
    }

    public postLicenses(licenses: SPHLicense[], authToken: string): Observable<any> {
        return this.httpClient
            .post(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/license/', licenses.map((license) => license.toJSON()), { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response: any[]) => response);
    }

    public patchLicense(licenseID: any, licensePatchDict: any, authToken: string): Observable<any> {
        return this.httpClient
            .patch(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/license/' + licenseID, licensePatchDict, { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response: any[]) => SPHCompany.fromJSON(response));
    }

    public resetLicense(licenseID: any, selectedApplications: SPHApplication[], authToken: string): Observable<any> {
        return this.getPhones(licenseID, authToken).flatMap((phones: any[]) => {
            const toBeDeleted = phones
            .filter((phone) =>  phone !== undefined && phone.id !== undefined && phone.application && phone.application.id !== undefined && selectedApplications.filter((application) => phone.application.id === application.id).length > 0)
            .map((phone) => {
                return this.httpClient
                    .delete(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/phone/' + phone.id, {headers: new HttpHeaders().set('Authorization', authToken)});
            });
            return toBeDeleted.length > 0 ? Observable.forkJoin(toBeDeleted) : Observable.of(true);
        });
    }

    public setLockLicense(licenseID: any, lock: boolean, authToken) {
        return this.patchLicense(licenseID, { locked: true }, authToken);
    }

    public deleteLicense(licenseID: any, authToken: string): Observable<void> {
        return this.httpClient
            .delete(
                LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/license/' + licenseID,
                { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response) => {
                console.debug('Deleted license response: ', response);
            });
    }

    public getPhones(licenseID: any, authToken: string): Observable<SPHPhone[]> {
        return this.httpClient
            .get(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/license/' + licenseID + '/phones', { headers: new HttpHeaders().set('Authorization', authToken) })
            .map( (response: any[]) => response.map(SPHPhone.fromJSON) );
    }

    public setAdminPasswordForCompany(companyID: string, password: string, authToken: string): Observable<any> {
        return this.httpClient
            .post(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/company/' + companyID + '/admin/password', { password }, { headers: new HttpHeaders().set('Authorization', authToken) });
    }

    public resetPassword(username: string): Observable<any> {
        return this.httpClient
            .post(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'login/reset', { username });
    }

    public handleHttpError<T>(failedString: string = 'Ausruf fehlgeschlagen', loading?: Loading, failSilentlyOnAuthError: boolean = true) {
        return (error: HttpErrorResponse): Observable<T> => {
            let message = error.message;
            if (error.error !== undefined && error.error.errors !== undefined && error.error.errors.length > 0) {
                message = error.error.errors[0].message;
            }
            if (error.status === 401) {
                this.authErrorLogginRequired$.next(true);
                if (failSilentlyOnAuthError) {
                    return;
                }
            }

            const alert = this.alertController.create({
                title: failedString,
                message: 'Fehler vom Server: ' + message,
                buttons: [
                    {
                        text: 'OK',
                        role: 'cancel',
                    },
                ]
            });
            if (loading !== undefined) {
                loading.dismiss();
            }
            alert.present();
            throw error;
        };
    }

    public setSublementaryLicenseInformation(preText: string, postText: string, preEmailText: string, postEmailText: string, authToken: string): Observable<any> {
        return this.httpClient
            .post(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/information/licensesupplemantary', { pre_license_text: preText, post_license_text: postText, pre_email_text: preEmailText, post_email_text: postEmailText }, { headers: new HttpHeaders().set('Authorization', authToken) });
    }

    public getSublementaryLicenseInformation(authToken: string): Observable<{ pre_license_text: string, post_license_text: string, pre_email_text: string, post_email_text: string }> {
        return this.httpClient
            .get(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/information/licensesupplemantary', { headers: new HttpHeaders().set('Authorization', authToken) })
            .map((response: any) => response);
    }

    public setSMTPCredentials(host: string, port: number, secure: boolean, user: string, pass: string, authToken: string): Observable<any> {
        return this.httpClient
            .post(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/information/smtpcredentials', { host, port, secure, user, pass }, { headers: new HttpHeaders().set('Authorization', authToken) });
    }

    public getSMTPCredentials(authToken: string): Observable<{ host: string, port: number, secure: boolean, user: string, pass: string }> {
        return this.httpClient
        .get(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/information/smtpcredentials', { headers: new HttpHeaders().set('Authorization', authToken) })
        .map((response: any) => response);
    }

    public deleteSMTPCredentials(authToken: string): Observable<any> {
        return this.httpClient
        .delete(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/information/smtpcredentials', { headers: new HttpHeaders().set('Authorization', authToken) })
        .map((response: any) => response);
    }

    public sendPush(topic: string, content: string, licenseID: any, applicationID: any, authToken: string): Observable<any> {
        return this.httpClient
            .post(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/license/' + licenseID + '/phone/push', { message: content, topic, application_id : applicationID }, { headers: new HttpHeaders().set('Authorization', authToken) });
    }

    public resendLicenses(licenses: SPHLicense[], companyId: any,  authToken: string): Observable<any> {
        return this.httpClient
            .post(LicenseManagerService.LICENSEMANAGER_SERVER_URL + 'rest/license/resend', { ids: licenses.map((license) => license.id), company_id: companyId }, { headers: new HttpHeaders().set('Authorization', authToken) });
    }
}



// WEBPACK FOOTER //
// ./src/app/features/shared/licensemanager-service/licensemanager.service.ts